/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { WorkStepPreviewDto } from './WorkStepPreviewDto';
import {
    WorkStepPreviewDtoFromJSON,
    WorkStepPreviewDtoFromJSONTyped,
    WorkStepPreviewDtoToJSON,
} from './WorkStepPreviewDto';
import type { InstructionDto } from './InstructionDto';
import {
    InstructionDtoFromJSON,
    InstructionDtoFromJSONTyped,
    InstructionDtoToJSON,
} from './InstructionDto';
import type { ReferredEntityChange } from './ReferredEntityChange';
import {
    ReferredEntityChangeFromJSON,
    ReferredEntityChangeFromJSONTyped,
    ReferredEntityChangeToJSON,
} from './ReferredEntityChange';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { GuidItemGroupDto } from './GuidItemGroupDto';
import {
    GuidItemGroupDtoFromJSON,
    GuidItemGroupDtoFromJSONTyped,
    GuidItemGroupDtoToJSON,
} from './GuidItemGroupDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface TaskInJobDto
 */
export interface TaskInJobDto {
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskInJobDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskInJobDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    taskId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    taskAreaId?: string;
    /**
     * 
     * @type {Array<GuidItemGroupDto>}
     * @memberof TaskInJobDto
     */
    supportSystemIds?: Array<GuidItemGroupDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof TaskInJobDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    description?: string | null;
    /**
     * 
     * @type {InstructionDto}
     * @memberof TaskInJobDto
     */
    instruction?: InstructionDto;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    readonly taskInJobId?: string;
    /**
     * 
     * @type {ReferredEntityChange}
     * @memberof TaskInJobDto
     */
    taskChange?: ReferredEntityChange;
    /**
     * 
     * @type {ReferredEntityChange}
     * @memberof TaskInJobDto
     */
    taskAreaChange?: ReferredEntityChange;
    /**
     * 
     * @type {number}
     * @memberof TaskInJobDto
     */
    index?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInJobDto
     */
    disabled?: boolean;
    /**
     * 
     * @type {StateOfUse}
     * @memberof TaskInJobDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {Array<WorkStepPreviewDto>}
     * @memberof TaskInJobDto
     */
    workSteps?: Array<WorkStepPreviewDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TaskInJobDto
     */
    $type?: TaskInJobDtoTypeEnum;
}


/**
 * @export
 */
export const TaskInJobDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoTaskInJobDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.TaskInJobDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskInJobDtoTypeEnum = typeof TaskInJobDtoTypeEnum[keyof typeof TaskInJobDtoTypeEnum];



/**
 * Check if a given object implements the TaskInJobDto interface.
 */
export function instanceOfTaskInJobDto(value?: unknown): value is TaskInJobDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskInJobDtoTypeEnum)[0];
}

export function TaskInJobDtoFromJSON(json: any): TaskInJobDto {
    return TaskInJobDtoFromJSONTyped(json, false);
}

export function TaskInJobDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskInJobDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'name': json['name'] == null ? undefined : json['name'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'taskAreaId': json['taskAreaId'] == null ? undefined : json['taskAreaId'],
        'supportSystemIds': json['supportSystemIds'] == null ? undefined : ((json['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoFromJSON)),
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'description': json['description'] == null ? undefined : json['description'],
        'instruction': json['instruction'] == null ? undefined : InstructionDtoFromJSON(json['instruction']),
        'taskInJobId': json['taskInJobId'] == null ? undefined : json['taskInJobId'],
        'taskChange': json['taskChange'] == null ? undefined : ReferredEntityChangeFromJSON(json['taskChange']),
        'taskAreaChange': json['taskAreaChange'] == null ? undefined : ReferredEntityChangeFromJSON(json['taskAreaChange']),
        'index': json['index'] == null ? undefined : json['index'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'workSteps': json['workSteps'] == null ? undefined : ((json['workSteps'] as Array<any>).map(WorkStepPreviewDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TaskInJobDtoToJSON(value?: Omit<TaskInJobDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'taskInJobId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'name': value['name'],
        'taskId': value['taskId'],
        'taskAreaId': value['taskAreaId'],
        'supportSystemIds': value['supportSystemIds'] == null ? undefined : ((value['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoToJSON)),
        'iuid': value['iuid'],
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'description': value['description'],
        'instruction': InstructionDtoToJSON(value['instruction']),
        'taskChange': ReferredEntityChangeToJSON(value['taskChange']),
        'taskAreaChange': ReferredEntityChangeToJSON(value['taskAreaChange']),
        'index': value['index'],
        'disabled': value['disabled'],
        'state': StateOfUseToJSON(value['state']),
        'workSteps': value['workSteps'] == null ? undefined : ((value['workSteps'] as Array<any>).map(WorkStepPreviewDtoToJSON)),
        '$type': value['$type'],
    });
}

